import { createReducer } from "redux-starter-kit";
import { appSetIssueProdAction } from "../actions/appIssueProdData";

const INIT_STATE = {};

const appIssueProdData = createReducer(INIT_STATE, {
  [appSetIssueProdAction]: (state, action) => {
    state[action.payload.issueProd.bid] = action.payload.issueProd;
  }
});

export default appIssueProdData;
